module.exports = __webpack_public_path__ + "img/Vector32.98eea6df.svg";